import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { actionCreators } from '../store/WeatherForecasts';

class FetchData extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const newIdx = parseInt(nextProps.match.params.startDateIndex, 10) || 0;
    if (prevState.prevStartIndex !== newIdx) {
      return { prevStartIndex: newIdx, _fetchNeeded: true };
    }
    return null;
  }

  componentDidMount() {
    const startDateIndex = parseInt(this.props.match.params.startDateIndex, 10) || 0;
    this.setState({ prevStartIndex: startDateIndex }, () => {
      this.props.requestWeatherForecasts(startDateIndex);
    });
  }

  componentDidUpdate() {
    if (this.state._fetchNeeded) {
      const startDateIndex = parseInt(this.props.match.params.startDateIndex, 10) || 0;
      this.setState({ _fetchNeeded: false }, () => {
        this.props.requestWeatherForecasts(startDateIndex);
      });
    }
  }

  state = {};

    render() {
    return (
      <div>
        <h1>Weather forecast</h1>
        <p>This component demonstrates fetching data from the server and working with URL parameters.</p>
        {renderForecastsTable(this.props)}
        {renderPagination(this.props)}
      </div>
    );
  }
}

function renderForecastsTable(props) {
  return (
    <table className='table'>
      <thead>
        <tr>
          <th>Date</th>
          <th>Temp. (C)</th>
          <th>Temp. (F)</th>
          <th>Summary</th>
        </tr>
      </thead>
      <tbody>
        {props.forecasts.map(forecast =>
          <tr key={forecast.dateFormatted}>
            <td>{forecast.dateFormatted}</td>
            <td>{forecast.temperatureC}</td>
            <td>{forecast.temperatureF}</td>
            <td>{forecast.summary}</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

function renderPagination(props) {
  const prevStartDateIndex = (props.startDateIndex || 0) - 5;
  const nextStartDateIndex = (props.startDateIndex || 0) + 5;

  return <div className='d-flex justify-content-between align-items-center'>
    <Link className='btn btn-secondary' to={`/fetchdata/${prevStartDateIndex}`}>Previous</Link>
    <small className='text-muted'>Page {prevStartDateIndex} / {nextStartDateIndex}</small>
    <Link className='btn btn-secondary' to={`/fetchdata/${nextStartDateIndex}`}>Next</Link>
    {props.isLoading ? <span className='ms-2'>Loading...</span> : []}
  </div>;
}

export default connect(
  state => state.weatherForecasts,
  dispatch => bindActionCreators(actionCreators, dispatch)
)(FetchData);
